import { Component, inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { REImgMasterDTO } from 'src/app/real-estate/Interface & Service/REImgMaster/reImgMaster.interface';

@Component({
  selector: 'app-listing-img-preview',
  templateUrl: './listing-img-preview.component.html',
  styleUrls: ['./listing-img-preview.component.css']
})
export class ListingImgPreviewComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  @Input() propertyImages: REImgMasterDTO[] = [];
  @Input() propertyTitle: string = '';
  groupedImages: { [key: string]: REImgMasterDTO[] } = {};
  categories: string[] = [];
  currentIndices: { [key: string]: number } = {};
  isCardView: boolean = true; // Default to Card View
  activeCategory: string = 'All'; // Default active category

ngOnInit(): void {
  if (this.propertyImages.length > 0) {
    // Group images by imgTitle, excluding empty or null titles from categories
    this.groupedImages = this.propertyImages.reduce((acc, img) => {
      const title = img.imgTitle && img.imgTitle.trim() ? img.imgTitle : 'All';
      if (!acc[title]) {
        acc[title] = [];
      }
      acc[title].push(img);
      return acc;
    }, {} as { [key: string]: REImgMasterDTO[] });

    // Ensure 'All' category includes all images
    this.groupedImages['All'] = [...this.propertyImages];

    // Extract unique categories, excluding null or empty titles
    const uniqueCategories: string[] = [...new Set(
      this.propertyImages
        .map(img => img.imgTitle && img.imgTitle.trim() ? img.imgTitle : undefined)
        .filter((title): title is string => title !== undefined)
    )];

    // Set categories, ensuring 'All' is first
    this.categories = ['All', ...uniqueCategories];

    // Sort images within each category by imgId (optional)
    for (const category in this.groupedImages) {
      this.groupedImages[category].sort((a, b) => (a.imgId || 0) - (b.imgId || 0));
    }

    // Initialize current index for each category
    this.categories.forEach(category => {
      this.currentIndices[category] = 0;
    });

    console.log('Grouped Images:', this.groupedImages);
    console.log('Categories:', this.categories);
  }
}
  // Set the active category when a tab is clicked
  setActiveCategory(category: string): void {
    this.activeCategory = category;
  }

  // Get images for a specific category
  getImagesForCategory(category: string): REImgMasterDTO[] {
    if (category === 'All') {
      return [...this.propertyImages].sort((a, b) => (a.imgId || 0) - (b.imgId || 0));
    }
    return this.groupedImages[category] || [];
  }

  // Get current image for a category
  getCurrentImage(category: string): REImgMasterDTO | null {
    const images = this.getImagesForCategory(category);
    const index = this.currentIndices[category] || 0;
    return images[index] || null;
  }

  // Select an image in Card View to switch to Single-Image View
  selectImage(category: string, image: REImgMasterDTO): void {
    this.isCardView = false; // Switch to Single-Image View
    this.activeCategory = category; // Set the active category
    const images = this.getImagesForCategory(category);
    this.currentIndices[category] = images.findIndex(img => img.imgId === image.imgId);
  }

  // Toggle between Card View and Single-Image View
  toggleView(): void {
    this.isCardView = !this.isCardView;
  }

  // Navigate to previous image
  prevImage(category: string): void {
    const images = this.getImagesForCategory(category);
    if (images.length > 0) {
      this.currentIndices[category] = (this.currentIndices[category] - 1 + images.length) % images.length;
    }
  }

  // Navigate to next image
  nextImage(category: string): void {
    const images = this.getImagesForCategory(category);
    if (images.length > 0) {
      this.currentIndices[category] = (this.currentIndices[category] + 1) % images.length;
    }
  }

  // Generate tab ID dynamically from category name
  getTabId(category: string): string {
    // Convert category to a URL-friendly ID (lowercase, replace spaces with hyphens)
    return category.toLowerCase().replace(/\s+/g, '-');
  }

  // Get the number of images for a category
  getImageCount(category: string): number {
    if (category === 'All') {
      return this.propertyImages.length;
    }
    return this.groupedImages[category]?.length || 0;
  }

  closeModal() {
    this.activeModal.dismiss();
  }
}